import React, {Component} from "react";

class PCBThickness extends Component {

    render() {
        return (
            <div className="container-fluid">
                <p> 下記、板厚をサポートしております。
                </p>
                <p> 0.4mm、0.6mm、0.8mm、1.0mm、1.2mm、1.6mm、2.0mm
                </p>
                <p> 板厚による公差
                </p>
                <p> 1.0mm未満の場合、板厚公差は±0.10mmです。
                </p>
                <p> 1.0mm以上の場合、板厚公差は±10％です。
                </p>

            </div>
        );
    }
}

export default PCBThickness;


// WEBPACK FOOTER //
// ./src/components/Site/QuotationForm/PCBThickness.js